import React, {useContext} from 'react';
import {Collaboration, Popup} from 'components';
import {useNamedSelector} from 'helpers';

export function MenuItem({ id, context }) {
  const popup = useContext(Popup.Context);
  const { premium } = useNamedSelector('session.subscription');
  const collaboration = useNamedSelector('relations.collaboration', { id, context });
  // @todo fix object.googleEventId
  return Boolean(premium) && (!collaboration || collaboration.shareable) && (
    <Popup.Menu.Item icon="share" onClick={popup.redirect(Collaboration.ShareMenu, { id, context })}>Share</Popup.Menu.Item>
  );
}
